import navbarLogo from '@/assets/themes/default/navbar-logo.svg';
import fullLogo from '@/assets/themes/default/full-logo.svg';
import chatAvatar from '@/assets/themes/default/chat-avatar.svg';
import favicon from '@/assets/themes/default/favicon.ico';
import type { ThemeDefinition } from '../types';

export const defaultTheme: ThemeDefinition = {
  id: 'default',
  name: 'Strive',
  pageTitle: 'Strivelabs Platform - Workflow intelligence for a smarter workforce',
  assets: {
    navbarLogo,
    fullLogo,
    chatAvatar,
    clerkLogoUrl: 'https://assets.apps.strivelabs.co/public-assets/Color+Filled+Black.svg',
    favicon,
  },
};
